import { gql } from '@apollo/client'

export const registerUserAndAcceptInvitationMutation = gql`
  mutation registerUserValidated(
    $firstName: String!
    $lastName: String!
    $birthDate: String!
    $termsAndConditions: Boolean!
  ) {
    registerUserValidated(
      firstName: $firstName
      lastName: $lastName
      birthDate: $birthDate
      termsAndConditions: $termsAndConditions
    ) {
      success
    }
  }
`
